export default __webpack_public_path__ + "static/media/join_button.38231a93.svg";